import apiClient from "../api/client";

export const FactureService = {
  // Factures
  async getFactures(params?: any) {
    const response = await apiClient.get("/factures/", { params });
    return response;
  },

  async getFacture(id: string) {
    const response = await apiClient.get(`/factures/${id}/`);
    return response;
  },

  async createFacture(data: any) {
    const response = await apiClient.post("/factures/", data);
    return response;
  },

  async uploadFacture(formData: FormData) {
    const response = await apiClient.post("/factures/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },

  async updateFacture(id: string, data: any) {
    const response = await apiClient.put(`/factures/${id}/`, data);
    return response;
  },

  async validerFacture(id: string) {
    const response = await apiClient.post(`/factures/${id}/valider/`);
    return response;
  },

  async rejeterFacture(id: string, motifs: string) {
    // Le backend attend le motif dans « commentaires »
    const response = await apiClient.post(`/factures/${id}/rejeter/`, {
      commentaires: motifs,
    });
    return response;
  },

  async getFactureStats() {
    const response = await apiClient.get("/factures/statistiques/");
    return response;
  },

  // Litiges
  async getLitiges(params?: any) {
    const response = await apiClient.get("/factures/litiges/", { params });
    return response;
  },

  async createLitige(data: any) {
    const response = await apiClient.post("/factures/litiges/", data);
    return response;
  },

  async resoudreLitige(id: string, solution: string) {
    const response = await apiClient.post(`/factures/litiges/${id}/resoudre/`, {
      solution,
    });
    return response;
  },

  // OCR
  async processOCR(factureId: string) {
    const response = await apiClient.post(
      `/factures/${factureId}/process-ocr/`
    );
    return response;
  },

  async downloadFacture(id: string) {
    // We get the facture details to get the file URL
    const response = await this.getFacture(id);
    return response.data.fichier_original;
  },

  // Scoring approval (finance agent)
  async approuverScoring(id: string, commentaires?: string, compteBancaireId?: string) {
    const payload: any = {
      commentaires: commentaires || "Scoring approuvé par agent finance",
    };
    if (compteBancaireId) {
      payload.compte_bancaire_id = compteBancaireId;
    }
    const response = await apiClient.post(`/factures/${id}/approuver-scoring/`, payload);
    return response;
  },

  async rejeterScoring(id: string, commentaires: string) {
    const response = await apiClient.post(`/factures/${id}/rejeter-scoring/`, {
      commentaires,
    });
    return response;
  },
};
